import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Shield03 = function Shield03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 2.5001v19m8-9.5c0 4.9085-5.354 8.4784-7.302 9.6149-.2214.1292-.3321.1937-.4883.2272-.1213.026-.2981.026-.4194 0-.1562-.0335-.2669-.098-.4883-.2272C9.354 20.4785 4 16.9086 4 12.0001V7.2177c0-.7995 0-1.1993.1308-1.5429a2 2 0 0 1 .5469-.7892c.2758-.243.6501-.3834 1.3987-.6641l5.3618-2.0107c.2079-.078.3118-.117.4188-.1324a1 1 0 0 1 .286 0c.107.0155.2109.0544.4188.1324l5.3618 2.0107c.7486.2807 1.1229.421 1.3987.6641.2437.2148.4314.4857.5469.7892C20 6.0184 20 6.4182 20 7.2178z"
    })
  }));
};
export default Shield03;